var a = /* @__PURE__ */ ((t) => (t.instagram = "instagram", t.tiktok = "tiktok", t.youtube = "youtube", t.snapchat = "snapchat", t))(a || {});
export {
  a as SOCIAL_PLATFORMS
};
//# sourceMappingURL=platforms.es.js.map
